import { Link } from 'react-router-dom';
import './Header.css';
import heroImg1 from "../assets/hero_img_1.png";
import heroImg2 from "../assets/hero_img_2.png";
import heroImg3 from "../assets/hero_img_3.png";
import heroImg4 from "../assets/hero_img_4.png";

function Header() {
  return (
    <header className="header">
      <div className="header-images-left">
        <Link to="/login" className="header-img-link">
          <img src={heroImg1} alt="AI in Safety" />
        </Link>
        <Link to="/contact" className="header-img-link"><img src={heroImg2} alt="Contact Us" /></Link>
      </div>

      <div className="header-container">
        <h1 className="header-title">WeCare EHS Consultancy</h1>
        <p className="header-para">Ensuring Safe, Healthy & Accident-free Workplace</p>
        <h2 className="header-subtitle">EHS SPECIALIST | AUDIT | TRAINING | COMPLIANCE | CONSULTANT</h2>
      </div>

      <div className="header-images-right">
        <a href="https://www.justdial.com/Thane/WeCare-EHS-Consultancy--Thane-West/022PXX22-XX22-250204193112-M7Q1_BZDET?ref=auto&searchfrom=auto|home" target="_blank" rel="noopener noreferrer" className="header-img-link">
          <img src={heroImg3} alt="Justdial" />
        </a>
        <div className="header-img-link" style={{ cursor: 'default' }}>
          <img src={heroImg4} alt="Facebook" />
        </div>
      </div>
    </header>
  );
}

export default Header;